import PageTitle from "./pageTitle";
import TeamGroup from "../groups/teamGroup";
import TextTemplate from "../cards/sampleText";
import CareerGroup from "../groups/careerGroup";
import { CompanyInfoContext } from "../../App";
import { useContext } from "react";
import MailSubscription from "../cards/emailSub";
import ContactForm from "../cards/contactForm";
import { Helmet } from "react-helmet-async";

const Careers = () => {
    const companyInfo = useContext(CompanyInfoContext);
    const careerBenefits = [
        {
            id: 1,
            title: "Careers with Codehub Technologies",
            description: `${companyInfo.career_benefits}`,
            pic_url:
                "https://img.freepik.com/free-photo/confident-african-businesswoman-smiling-closeup-portrait-jobs-career-campaign_53876-143280.jpg?w=826&t=st=1706094006~exp=1706094606~hmac=b814bce95d6fc997b90f0d20c5e3ee6050798fcd24bd9ac1dbe0784d9fd36bfa",
        },
    ];
    return (
        <>
            <Helmet>
                <title>Careers - Codehub Technologies</title>
            </Helmet>

            <PageTitle title="Careers" />
            {companyInfo.career_benefits && (
                <TextTemplate dataList={careerBenefits} />
            )}

            <CareerGroup />
            <TeamGroup />
            <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-14 sm:cht-py-16 !cht-font-body">
                <div className="cht-max-w-2xl cht-mx-auto cht-text-center cht-bg-slate-50/70 cht-p-8 sm:cht-p-10 cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-soft">
                    <h3 className="cht-text-2xl sm:cht-text-3xl cht-font-bold !cht-font-heading cht-text-[#1e293b]">
                        Didn't Find A Suitable Position?
                    </h3>
                    <p className="cht-text-sm sm:cht-text-base cht-text-slate-600 cht-mt-3 cht-leading-relaxed">
                        Send your CV to{" "}
                        <a
                            className="cht-font-semibold cht-text-[#3e57da] hover:cht-underline !cht-no-underline"
                            href="mailto:codehubtechnologies1@gmail.com"
                        >
                            codehubtechnologies1@gmail.com
                        </a>{" "}
                        and stay updated about our future openings.
                    </p>
                </div>
            </section>

            <MailSubscription />
            <ContactForm />
        </>
    );
};

export default Careers;
